document.addEventListener('DOMContentLoaded', () => {
    const originalButtonsContainer = document.querySelector('.product-form__buttons');
    const stickyButtonContainer = document.querySelector('[data-product-submit-button]');
    const productForm = originalButtonsContainer?.closest('form');
    const buyButtons = document.querySelector('[data-product-block="buy_buttons"]');
    const stickyContainer = document.querySelector('[data-product-form-sticky]');

    if (!originalButtonsContainer || !stickyButtonContainer || !productForm) return;

    function cloneButtons() {

        stickyButtonContainer.innerHTML = '';

        const clonedButtons = originalButtonsContainer.cloneNode(true);
        stickyButtonContainer.appendChild(clonedButtons);

        const clonedSubmitBtn = clonedButtons.querySelector('[type="submit"], button:not([type])');
        if (clonedSubmitBtn) {
            clonedSubmitBtn.addEventListener('click', (e) => {
                e.preventDefault();
                productForm.requestSubmit();
            });
        }
    }

    cloneButtons();

    const observer = new MutationObserver(() => {
        // If the original buttons change, re-clone to keep the sticky version in sync
        cloneButtons();
    });

    observer.observe(originalButtonsContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true,
    });

    function isInView(element) {
        const rect = element.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom >= 0;
      }

      function checkVisibility() {
        if (!isInView(buyButtons)) {
          stickyContainer.classList.add('is--active');
        } else {
          stickyContainer.classList.remove('is--active');
        }
      }

      window.addEventListener('scroll', checkVisibility, { passive: true });
      checkVisibility();

});
